<template>
  <BookingList list-title="Booking" />
</template>

<script>
import BookingList from '@/components/Booking/BookingList';

export default {
  name: 'booking',
  components: {
    BookingList,
  },
};
</script>
